var Layer = require("./Layer"),
    $     = require("jquery"),
    ol    = require("openlayers");

var _ = require("underscore");

var VectorLayer = Layer.extend({

    /**
     *
     * @param options
     */
    initialize: function(options){
        var that = this;
        VectorLayer.__super__.initialize.call(that, options);

        that._olLayer = new ol.layer.Vector({
            'visible': options.visible
        });

        that._olLayer.set('omjsLayer', that);
        that._setup(options);
    },

    /**
     *
     * @param options
     * @private
     */
    _setup: function(options){
        var that     = this,
            prjLayer,
            features;

        options || (options = {});

        if('projectLayers' in options){
            that._prjLayers = options.projectLayers;
        }

        if(that._prjLayers && that._prjLayers.getLength() > 0){
            //prjLayer = that._prjLayers.at(0);

            //prjLayer.objects.each(function(obj, i){
            //    var geom = obj.getGeometry();
//
            //    if(geom && geom.type in ol.geom){
            //        obj.feature = new ol.Feature({
            //            obj     : obj,
            //            geometry: new ol.geom[geom.type](geom.coordinates)
            //        });
            //        obj.feature.setId(obj.id);
            //        features.push(obj.feature);
            //    }
            //});

            that._olSource = new ol.source.Vector({
                features: that.getFeatures()
            });

            if(that.options['clustering']){
                that._olClusterSource = new ol.source.Cluster({
                    distance: that.options['clustering'],
                    source  : that._olSource
                });
                that._olLayer.setSource(that._olClusterSource);
            }else{
                that._olLayer.setSource(that._olSource);
            }
        }
        return that;
    },

    getFeatures: function() {
        var that = this,
            features = [];

        that._prjLayers.at(0).objects.each(function(obj, i){
            var geom = obj.getGeometry();

            if(geom && geom.type in ol.geom){
                obj.feature = new ol.Feature({
                    obj     : obj,
                    geometry: new ol.geom[geom.type](geom.coordinates)
                });
                obj.feature.setId(obj.id);
                features.push(obj.feature);
            }
        });

        return features;
    },

    updateLayer: function() {
        var that = this;
        that._prjLayers.at(0).loadObjects(that.options).then(function () {
            that._olSource.clear();
            that._olSource.addFeatures(that.getFeatures());
        });

    },

    setStyle: function(style){
        var that = this;
        that._olLayer.setStyle(style);
    },

    syncWithProject: function(){
        var that = this;
        var projectLayer = that.getProjectLayers();

        if (!projectLayer) {
            return false;
        }

        projectLayer = projectLayer.at(0);

        if (projectLayer) {
            if (projectLayer.get('selected')) {
                that.show();
            } else {
                that.hide();
            }
        }
    }
});

module.exports = VectorLayer;



//////////////////
// WEBPACK FOOTER
// ./src/View/VectorLayer.js
// module id = 44
// module chunks = 0